import { Navigate } from 'react-router-dom'
import { SandboxImagesTable } from '@/components/sandbox-images'
import { useAuth } from '@/hooks/useAuth'
import { useSandboxImages } from '@/hooks'
import { Permissions } from '@/lib/permissions'

export function SandboxImagesAdminPage() {
  const { isAdmin, hasPermission, isLoading: authLoading } = useAuth()
  const canView = isAdmin || hasPermission(Permissions.Host.SandboxImage.List)

  const { data: images, isLoading } = useSandboxImages(canView)

  if (authLoading) return null

  if (!canView) {
    return <Navigate to="/projects" replace />
  }

  return (
    <div className="space-y-5" aria-label="Sandbox images admin">
      <div>
        <h1 className="text-3xl font-bold">Sandbox Images</h1>
        <p className="text-sm text-muted-foreground">
          Platform-managed catalog of container images available for tenants and projects. Entries are seeded by the Migrator and cannot be edited from the UI.
        </p>
      </div>

      <div className="rounded-md border">
        <SandboxImagesTable images={images ?? []} isLoading={isLoading} />
      </div>
    </div>
  )
}
